import { render } from "./Salary.vue?vue&type=template&id=3d2a38b0&scoped=true"
import script from "./Salary.vue?vue&type=script&lang=js"
export * from "./Salary.vue?vue&type=script&lang=js"

import "./Salary.vue?vue&type=style&index=0&id=3d2a38b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2a38b0"]])

export default __exports__